module.exports = __webpack_public_path__ + "img/step5-02.8df650d6.jpg";